'use client'; // Error components must be Client Components

import { ErrorBoundary } from '@bts-web/core-features/error';

const ErrorPage = (error: Error & { digest?: string }) => (
  <ErrorBoundary error={error} isTopLevel />
);

export default ErrorPage;
